import { css } from 'aphrodite'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import LoadCard from '../components/LoadCard'
import LoadTable from '../components/LoadTable'
import SubmitButton from '../components/SubmitButton'
import TagHeader from '../components/TagHeader'
import { useLoadContext } from '../contexts/LoadContext'
import { useTagContext } from '../contexts/TagContext'
import { loadDashboardStyles } from './LoadDashboard'

const DriverConfirmation: React.FC = () => {
  const { tagId } = useParams()
  const navigate = useNavigate()
  const { loads, isLoading, error, getLoadsByTag } = useLoadContext()
  const { getCurrentTag } = useTagContext()
  const currentTag = getCurrentTag(tagId)

  useEffect(() => {
    if (tagId) {
      getLoadsByTag(tagId)
    }
  }, [tagId, getLoadsByTag])

  const handleEditLoad = (loadNumber: number, loadId: number) => {
    if (tagId) {
      navigate(`/tags/open/${tagId}/${loadNumber}/details`, {
        state: { loadId },
      })
    }
  }

  if (isLoading) {
    return (
      <div className={css(loadDashboardStyles.pageContainer)}>
        <TagHeader
          tagId={tagId}
          title="Confirmation page"
          status={currentTag?.status || 'IN_PROGRESS'}
        />
        <div>Loading...</div>
      </div>
    )
  }

  return (
    <div className={css(loadDashboardStyles.pageContainer)}>
      <TagHeader
        tagId={tagId}
        title="Home confirmation"
        initialIsExpanded={true}
        isDetailed={true}
        status={currentTag?.status || 'IN_PROGRESS'}
        backUrl={`/tags/open/${tagId}/expenses`}
      />
      <div className={css(loadDashboardStyles.container)}>
        <div className={css(loadDashboardStyles.tableSection)}>
          {tagId && <LoadTable tagId={tagId} />}
        </div>
        <div className={css(loadDashboardStyles.submitButtonContainer)}>
          <SubmitButton
            canSubmit={true}
            text="Accept & Sign"
            onClick={() => navigate(`/tags/open/${tagId}/sign`)}
          />
        </div>
      </div>
    </div>
  )
}

export default DriverConfirmation
